import React from 'react'
import {Link}from 'react-scroll'
import onTopButton from "../../images/Footer Button.png";
import reactLogo from "../../images/React Logo.png";

export default function Footer() {
  return (
    <div className='footer-body'>
    <div className='footer-content'>
    <p className='footer-text'>&copy; ANDREJS GROCS 2025</p>
         <a className="btn-back"><Link activeClass="active" to="landing" spy={true} smooth={true} offset={50} duration={500} >
         <img className='btn-back-pic' src={onTopButton} alt='wind energy' />
        </Link></a> 
        
        <div className='text-and-logo'>
        
        <div className='text-block'>
        <p className='footer-text'>This website is created</p>
        <p className='footer-text'>with React technology </p>
        </div>
    

        
        <img className='react-logo' src={reactLogo} alt='wind energy' />

        </div>
        </div>
        
        


        
    </div>
    
  )
}
